import { Outlet } from "@tanstack/react-router";
// import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { NatsProvider } from "@/common/providers/nats-provider";
import { ReloadConfigProvider } from "@/common/contexts/ReloadConfigContext";
import CopyrightFooter from "@/common/ui/footer";
import { FOOTER_HEIGHT, NAVBAR_HEIGHT } from "@/common/constants/layout";

export default function RootLayout() {
	return (
		<NatsProvider>
			<ReloadConfigProvider>
				<div className="flex flex-col h-screen">
					<main
						className="overflow-y-auto flex-1"
						style={{
							height: `calc(100vh - ${NAVBAR_HEIGHT}px - ${FOOTER_HEIGHT}px)`,
						}}
					>
						<Outlet />
					</main>
					<CopyrightFooter />
					{/* <TanStackRouterDevtools /> */}
				</div>
			</ReloadConfigProvider>
		</NatsProvider>
	);
}
